import { Map } from 'immutable';

import {
  GIFTBIT_REWARDS__FETCH,
  GIFTBIT_AVAILABLE_REWARDS__UNLINK,
  USER__LOG_OFF,
} from '../constants';
import * as utils from '../../util';

const defaultState = new Map();

export default function (state = defaultState, action) {
  switch (action.type) {
    case GIFTBIT_REWARDS__FETCH:
      return utils.mergeJsonArray(
        defaultState,
        action.data.map((reward) => ({
          ...reward,
          elementId: action.elementId,
        })),
      );
    case GIFTBIT_AVAILABLE_REWARDS__UNLINK:
      return state.delete(action.rewardId);
    case USER__LOG_OFF:
      return defaultState;
    default:
      return state;
  }
}

export const select = (state) => state.model.toJS();
